let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fgxCU")).then(() => parcelRequire('i878A'));